'use es6';

export const FILENAME_MAX_LENGTH_CUSTOM_WIDGET = 100;
export const FILENAME_MAX_LENGTH_CHILD_THEME = 100;
export const FILENAME_MAX_LENGTH_CHILD_THEME_FILES = 50;
export const FILENAME_MAX_LENGTH_DEFAULT = 250;
export const FILE_UPLOAD_MEDIA_TYPES = ['text/css', 'text/javascript', 'application/json', 'text/html', 'text/plain', 'text/x-markdown', 'image/jpeg', 'image/png', 'image/gif', 'image/svg+xml', 'font/ttf', 'font/woff', 'font/woff2', '.css', '.js', '.html', '.txt', '.json', '.md', '.map', '.jpeg', '.jpg', '.png', '.gif', '.svg', '.ttf', '.woff', '.woff2'];
export const RECENT_FILES_DISPLAY_LIMIT = 5;